import React from 'react'

const FeesPayment = () => {
  return (
    <div>
      FeesPayment
    </div>
  )
}

export default FeesPayment